<template>
  <div class="text-center">
    <v-dialog v-model="dialog" max-width="500px">
      <v-card>
        <v-card-title class="blue-grey darken-4 py-5"></v-card-title>

        <v-card-text>
          <div class="py-6">
            <h1 class="text-center">Oops! Something went wrong</h1>
            <h4 class="text-center mt-2">
              Please contact our staff or try to refresh a page again
            </h4>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-btn color="blue-grey darken-4" class="mx-auto white--text mb-2" @click="closeModal">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "modal-error",
  data() {
    return {
      dialog: false
    };
  },
  computed: {
    ...mapGetters("Layout", ["getShowError"])
  },
  watch: {
    getShowError(val) {
      this.dialog = val;
    }
  },
  methods: {
    closeModal() {
      this.$store.dispatch("Layout/CLOSE_ERROR_MODAL");
    }
  }
};
</script>
